export default __webpack_public_path__ + "static/media/ilus1.0d279764.jpeg";